import type { InjectionKey } from 'vue'

/** When true (provided only under Weekly Check-In print routes), form controls omit placeholder / hint copy. */
export const WEEKLY_CHECK_IN_SUPPRESS_PLACEHOLDERS: InjectionKey<boolean> = Symbol(
  'WEEKLY_CHECK_IN_SUPPRESS_PLACEHOLDERS'
)
